import {FC} from 'react';

import s from '../styles.module.scss';

interface RemovalRequestFinishProps {
  siteName: string;
}

export const RemovalRequestFinish: FC<RemovalRequestFinishProps> = ({siteName}) => (
  <div className={s['removal-request-result']}>
    <p className={s['removal-request-result__header']}>Thank you for contacting {siteName}.</p>
    <p className={s['removal-request-result__p']}>
      Your removal request has been received and is being reviewed.
    </p>
    <p className={s['removal-request-result__p']}>
      Our team will review your request within a few days. Please do not submit duplicate requests
      as it can slow down this process.
    </p>
    <p className={s['removal-request-result__p']}>Thank you for your comprehension.</p>
  </div>
);
